import React from 'react';
import { Typography } from '@material-ui/core';

const Copyright: React.FC = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      © 2023 Attain Data, Inc. All rights reserved
    </Typography>
  );
};

export default Copyright;
